

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// updateTier
// UPDATETIER
const UPDATETIER= createAsyncThunk(
  "updateTier/updateTier",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateTierSlice = createSlice({
  name: "updateTierSlice",
  initialState: {
    updateTier: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateTier: (state) => {
        state.updateTier.loading = false
        state.updateTier.error = false
        state.updateTier.data = []
        state.updateTier.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATETIER.fulfilled, (state, action) => {
      state.updateTier = {
        ...state.updateTier,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATETIER.pending, (state, action) => {
      state.updateTier = {
        ...state.updateTier,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATETIER.rejected, (state, action) => {
      state.updateTier = {
        ...state.updateTier,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateTierAction = {
    UPDATETIER,
};

export { updateTierAction };
export default updateTierSlice.reducer;
export const {setInitialStateOfupdateTier} = updateTierSlice.actions
